import gql from 'graphql-tag';

export default gql`
  query forgotPasswordTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          common {
            forgotPasswordTitle
            forgotPasswordCta
            forgotPasswordDisclaimer
            forgotPasswordSubmitText
            forgotPasswordFieldLabel
            forgotPasswordSuccessText
          }
        }
      }
    }
  }
`;
